import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

/**
 * A simple step indicator component for wizards.
 * Displays step labels with completed/active/inactive states.
 *
 * TODO: Migrate to wrap neo-stepper from @neogov/pattern-library/neo-stepper.
 * This requires restructuring consumers (create-role page) to use <neo-step> children
 * with content projection instead of @if (currentStep() === N) blocks.
 */
@Component({
  selector: 'cm-stepper',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepperComponent {
  public readonly steps = input<string[]>([]);
  public readonly activeIndex = input<number>(0);
  public readonly ariaLabel = input<string>('Progress');
}
